import Component from '../../../assets/scripts/modules/component'

export default class AccordionComponent extends Component {
  init () {
    this.accordionButtons = this.element.querySelectorAll('.accordion-item')

    for (const button of this.accordionButtons) {
      if (button.classList.contains('open')) {
        this.setPanelHeight(button, true)
      }

      button.querySelector('.accordion-item__button').addEventListener('click', () => {
        this.toggleAccordion(button)
      })
    }
  }

  toggleAccordion (button) {
    button.classList.toggle('open')
    this.setPanelHeight(button, button.classList.contains('open'))
  }

  setPanelHeight (button, open) {
    button.querySelector('.accordion-item__button').setAttribute('aria-expanded', open)
    const target = button.querySelector('.accordion-item__title').dataset.target
    const panel = button.querySelector(`#${target}`)
    if (panel) {
      panel.style.maxHeight = open ? `${panel.scrollHeight}px` : null
    }
  }
}

window.addEventListener('init-load', () => document.querySelectorAll('.accordion').forEach(element => {
  element.instance = element.instance || new AccordionComponent(element)
}))
